<template>
	<div :class="has_error?'errorous no-after':''">
		<h5 class="simple-form-label mb-0" :class="'text-'+type">{{	label }}</h5>
		<label v-if="has_error"> {{	error_text }}</label>
	</div>

</template>
<script>
	export default {
		name: 'SimplementsFormLabel',
		props: {
			label: {
				type: String
			},
			type: {
				type: String,
				default: 'secondary'
			},
			has_error: {
				type: Boolean,
				default: false
			},
			error_text: {
				type: String
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	h5.simple-form-label{
		

		/* Title/Medium */
		font-family: Roboto;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 24px; /* 150% */
		letter-spacing: 0.1px;
	}
	h5.simple-form-label.text-secondary{
		color: var(--neutral10) !important;
	}
	h5.simple-form-label.text-primary{
		color: var(--primary) !important;
	}
	.errorous h5.simple-form-label.text-secondary,
	.errorous h5.simple-form-label.text-primary{
		color: var(--error) !important;
	}
</style>